<div class="rec-resources app-tabs-container">
    <div class="row">
        <div class="col-md-12">
            <div class="title">
                Per Diem Recruiter Resources
            </div>
        </div>
    </div>
    @if(isDoneLoading()) {
        <nova-followup-picker-perdiem [canEdit]="canEdit" [showLabel]="true" [showFollowupReason]="true" [currentFollowup]="followup"></nova-followup-picker-perdiem>
    }
</div>
